/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ServerInfo } from '../models/index';
import { ServerInfoFromJSON, ServerInfoToJSON } from '../models/index';

/**
 * HealthCheckApi - interface
 *
 * @export
 * @interface HealthCheckApiInterface
 */
export interface HealthCheckApiInterface {
	/**
	 * Get serverInfo
	 * @summary Get serverInfo
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof HealthCheckApiInterface
	 */
	getServerInfoRaw(
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServerInfo>>;

	/**
	 * Get serverInfo
	 * Get serverInfo
	 */
	getServerInfo(
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServerInfo>;
}

/**
 *
 */
export class HealthCheckApi extends runtime.BaseAPI implements HealthCheckApiInterface {
	/**
	 * Get serverInfo
	 * Get serverInfo
	 */
	async getServerInfoRaw(
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServerInfo>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/server`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ServerInfoFromJSON(jsonValue)
		);
	}

	/**
	 * Get serverInfo
	 * Get serverInfo
	 */
	async getServerInfo(
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServerInfo> {
		const response = await this.getServerInfoRaw(initOverrides);
		return await response.value();
	}
}
